<template>
	<div class="item">
		<span>{{ data.paytime || data.time }}</span>
		<span>{{ data.name }}</span>
		<span>{{ data.prize }}</span>
	</div>
</template>

<script>
export default {
	name: 'PrizeItem',
	props: {
		data: {
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>
.item {
	box-sizing: border-box;
	padding: 0 15px;
	@include flex-center;
	height: 28px;
	line-height: 28px;
	span {
		font-size: $small-font-size;
		color: $grey-font-color;
		text-align: left;
		width: 25%;
		&:first-child {
			width: 50%;
		}
	}
}
</style>
